export default __webpack_public_path__ + "images/B5.da9d03c.png";